export function pixelToRem(pixel: number, base: number = 10): string {
    return `${pixel / base}rem`;
}
